<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    import store from './store'

    export default {
        computed: {
            isLoggedIn: function () {
                return this.$store.getters.isLoggedIn
            }
        },
        methods: {
            logout: function () {
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.push('/login')
                    })
            }
        },
        created: function () {
            this.$http.interceptors.response.use(function (response) {
                return response
            }, function (error) {
                console.log(error.response.data)
                if (error.response.status === 401) {
                    store.dispatch('logout')
                }
                return Promise.reject(error)
            });
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }


</style>
